interface InfoIconProps { size?: number; }

export default function InfoIcon({ size = 18 }: InfoIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      style={{ display: "inline-block", flexShrink: 0, verticalAlign: "middle" }}
    >
      {/* Hard offset shadow — same +2,+2 language as lock icon's translate(12 12) */}
      <circle cx="12" cy="12" r="7.5" fill="#1A1A1A" />
      {/* Main circle: white fill, thick ink outline */}
      <circle cx="10" cy="10" r="7.5" fill="#FFFFFF" stroke="#1A1A1A" strokeWidth="2" />
      {/* i — dot */}
      <circle cx="10" cy="6.8" r="1.4" fill="#1A1A1A" />
      {/* i — stem */}
      <line x1="10" y1="9.2" x2="10" y2="13.8" stroke="#1A1A1A" strokeWidth="2.2" strokeLinecap="round" />
    </svg>
  );
}
